import { jsx as _jsx } from "react/jsx-runtime";
import { getPathValue, isRenderCell, validateValue } from "../util";
import { StyledTableCell } from "./styledtablecell.styles";
export function Cell({ record, dataIndex, render, additionalProps, index, children, colSpan, width = "auto", font, align = "left", }) {
    let cellProps;
    let childNode;
    if (validateValue(children)) {
        childNode = children;
    }
    else {
        const value = getPathValue(record, dataIndex);
        childNode = value;
        if (render) {
            const renderData = render(value, record, index);
            if (isRenderCell(renderData)) {
                childNode = renderData.children;
                cellProps = renderData.props;
            }
            else {
                childNode = renderData;
            }
        }
    }
    return (_jsx(StyledTableCell, Object.assign({ align: align, font: font, width: width || "auto" }, additionalProps, cellProps, { colSpan: colSpan, onKeyDown: (e) => {
            if (e.key === "Enter" || e.key === "Space" || e.key === " ")
                if (additionalProps) {
                    additionalProps.onClick(e);
                }
        } }, { children: childNode })));
}
